export function friendlyAuthError(err: unknown): string {
  const code = (err as { code?: string }).code ?? '';
  switch (code) {
    case 'auth/invalid-email': return 'That email address looks invalid.';
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential': return 'Email or password is incorrect.';
    case 'auth/email-already-in-use': return 'An account with that email already exists.';
    case 'auth/weak-password': return 'Pick a longer password — at least 6 characters.';
    case 'auth/popup-closed-by-user': return 'Sign-in cancelled.';
    case 'auth/user-disabled': return 'This account has been disabled. Contact support for help.';
    case 'auth/too-many-requests': return 'Too many sign-in attempts. Wait a few minutes, then try again.';
    case 'auth/network-request-failed': return 'We could not reach the sign-in service. Check your connection and try again.';
    default: return 'We could not sign you in. Try again.';
  }
}
